import ConditionalWrapper from "@components/common/ConditionalWrapper";
import Link from "next/link";

interface IBreadcrumbItem {
  label: string;
  href?: string;
  isCurrentPage: boolean;
}

const BreadcrumbItem = ({
                          label,
                          href,
                          isCurrentPage,
                        }: IBreadcrumbItem): JSX.Element => {
  return (
    <div className="h-fit w-fit self-center">
      <ConditionalWrapper
        condition={!!href}
        wrapper={(children) => <Link
          href={href ?? "/"}
          prefetch={false}>{children}</Link>}
      >
        <div
          className="whitespace-nowrap text-p13 font-medium text-lightblue hover:text-darkblue"
          aria-current={isCurrentPage ? "page" : "false"}
        >
          {label}
        </div>
      </ConditionalWrapper>
    </div>
  );
};

export default BreadcrumbItem;
